// extracted by mini-css-extract-plugin
export default {"heading":"HeadingText_heading__NOe8T","headingText_color":"HeadingText_headingText_color__4Olnz","headingText_title":"HeadingText_headingText_title__6dnQR"};